<style src="./Cp1SuggestProduct.scss" lang="scss"></style>
<template>
  <input-suggest
    :label="label"
    :placeholder="placeholder"
    @blur="blur"
    :rules="rules"
    v-model="inputValue"
    min="2">

    <input-suggest-item
      v-for="(item, idx) in suggestionList"
      :key="idx"
      :idx="idx"
      :item="item"
      class="client-item">

      <div class="client-row-top">
        <span class="lab">{{ item.lab }}</span>
        <span class="pativo">{{ item.pativo }}</span>
        <span class="comercialname">{{ item.comercialName }}</span>
      </div>
    </input-suggest-item>
  </input-suggest>
</template>
<script>
import InputSuggest from '../../cp1-input-suggest/InputSuggest'
import { InputSuggestMixin, InputSuggestItem } from '@/components/primitives/input-suggest'
import { SearchStock } from '@/brain/record/stock'

export default {
  name: 'Cp1SuggestPativo',
  mixins: [InputSuggestMixin],
  components: {
    InputSuggest,
    InputSuggestItem
  },
  data () {
    return {
      captionRaw: 'comercialName'
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    async doSearch (pSearchTerm) {
      const stock = await SearchStock({
        params: {
          skip: 0,
          limit: 100,
          filters: {
            searchText: pSearchTerm
          }
        }
      })

      const filteredList = []
      stock.list.map(i => {
        if (!filteredList.some(e => e.pativo === i.pativo)) {
          filteredList.push(i)
        }
      })
      return filteredList
    },
    selectingItemFromSuggestList (pItem) {
      this.inputValue = `${pItem.comercialName} - ${pItem.lab}`
      const outputFormated = this.createOutput(pItem)
      this.suggestionList = []
      this.$emit('selected', outputFormated)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/suggest/cp1-suggest-product/Cp1SuggestProduct.vue